// Global styles load here, before any page's bundle, so they always come
// before component styles in the cascade.
import "./src/styles/index.css";
import { trackPageView } from "./src/utils/analytics";
import { registerWebMcpTools } from "./src/utils/webmcp";

// Tools for AI agents in browsers that support WebMCP. Registered once: they
// belong to the site, not a page, and survive client-side navigation.
export const onClientEntry = () => {
  registerWebMcpTools();
};

// After client-side navigation (not the first page load), move focus to the
// new page's title, so screen reader and keyboard users start at the top of
// the new content instead of back at the start of the page.
export const onRouteUpdate = ({ location, prevLocation }) => {
  // Only if the reader accepted analytics cookies
  trackPageView();

  if (!prevLocation || location.hash) return;

  // Gatsby's router focuses its own wrapper shortly after this runs. For half
  // a second, put focus back on the title whenever it lands on the wrapper or
  // the page body, but never take it from something the reader moved to.
  const wrapper = document.getElementById("gatsby-focus-wrapper");
  let checks = 0;
  const focusTitle = () => {
    const title = document.getElementById("page-title");
    const active = document.activeElement;
    if (title && (active === document.body || active === wrapper)) {
      title.focus({ preventScroll: true });
    }
    if (++checks < 10) window.setTimeout(focusTitle, 50);
  };
  focusTitle();
};
